/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ulAvisos[_ngcontent-%COMP%]{height:29vh!important;overflow:auto}"];
export { styles as styles };
